import {rootContext} from '@/store'

export function isTrafficType({type}: {type: string}, trafficType: DbiApi.TrafficType): boolean {
    return rootContext.state.trafficTypes[trafficType].includes(type)
}
